<!-- Mon profil content -->
<section id="monprofil-content">
  <div class="flexible flex-just-center">
    <div class="wrapper wrapper-bis">
      <div class="my-profil-bar">
        mon profil
      </div>
      <div class="row col-md-12">
       <!--<div class="col-md-3" style="padding-top: 50px">
          <div class="profil-row-btn {{blocIsVisible('profilDataIsActive')?'profil-row-active':''}}" (click)="goToBlocItem('profilDataIsActive')">Mes informatons</div>
          <div class="profil-row-btn {{blocIsVisible('profilDocumentIsActive')?'profil-row-active':''}}" (click)="goToBlocItem('profilDocumentIsActive')">Mes documents</div>
          <div class="profil-row-btn {{blocIsVisible('profilRibIsActive')?'profil-row-active':''}}" (click)="goToBlocItem('profilRibIsActive')">Mon rib</div>
        </div>-->
        <div class="col-md-12 m-rl-auto">
          <div class="container rmp override-container" style="margin-top: 20px">
            <div *ngIf="blocIsVisible('profilDataIsActive')">
              <app-crop-modal *ngIf="cropperBannerSettings" [cropsettings]="cropperBannerSettings" [name]="bannerModalname" [index]="bannerModalindex" #cropperModal>
              </app-crop-modal>
              <!--<div class="">
                <h5 class="my-infos">Mon profil</h5>
              </div>-->

              <form (ngSubmit)="onSubmit(profileForm.valid)" #profileForm="ngForm">
                <div class="container mt-15 " style="margin-bottom: 80px">
                  <div class="mb-20">
                    <div class="photo-profil"><span>Photo de profil</span></div>
                    <div class="text-center">
                      <div class="circle-70 {{userIsMale(user)?'p-men-color':'p-women-color'}} mt-10 bgc-lg inline-block mr-10p ft-30p">
                        <span *ngIf="!(user.avatar || editningAvatar)" class="mt-17p mt-16p h-110p fs-24p inline-block" >{{getInitial(user.firstname+ ' '+user.lastname)}}</span>

                        <div *ngIf="user.avatar || editningAvatar">
                          <img *ngIf="editningAvatar" class="rounded-img"  [src]="cropperModal.Imgdata.image || user.avatar|assetimage" onError="this.src = 'assets/imgs/banner.png'">
                          <img *ngIf="!editningAvatar" class="rounded-img" [src]=" user.avatar|assetimage">
                        </div>

                      </div>
                    </div>
                    <div class="center mt-15p">
                      <button class="edit-pic-btn" (click)="editPicBtn($event)">Changer la photo</button>
                      <input type="file" (change)="userAvatarFileListenner($event)" id="edit-pic-btn" style="display: none">
                    </div>
                  </div>

                  <!-- <h4 class="text-center  text-uppercase block" style="margin-bottom: 30px;margin-top: 19px;color: #16baff">Informations</h4>-->

                  <div class="alert alert-success" role="alert" *ngIf="!errorMsg && success">
                    {{'front_profil.data_updated'| translate}}
                  </div>

                  <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
                    {{ errorMsg | translate }}
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (firstname.errors && (firstname.dirty || firstname.touched || errorMsg))}">
                      <label class="header-color">{{'front_profil.firstname'| translate}}</label>
                      <div class="rmp">
                        <input type="text" name="firstname" placeholder="{{'front_profil.firstname'| translate}}"
                               value="{{user.firstname}}" [(ngModel)]="user.firstname" #firstname="ngModel" required
                               class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_firstname_is_required'| translate}}
                      </div>
                    </div>

                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (lastname.errors && (lastname.dirty || lastname.touched || errorMsg))}">
                      <label class="header-color">{{'front_profil.lastname'| translate}}</label>
                      <div class="rmp">
                        <input type="text" name="lastname" placeholder="{{'front_profil.lastname'| translate}}"
                               value="{{user.lastname}}" [(ngModel)]="user.lastname" #lastname="ngModel" required
                               class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_lastname_is_required'| translate}}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (email.errors && (email.dirty || email.touched || errorMsg))}">
                      <label class="header-color">{{'front_profil.email'| translate}}</label>
                      <div class="rmp">
                        <input disabled type="email" name="email" placeholder="Adresse email" #email="ngModel" value="{{user.email}}" [(ngModel)]="user.email" class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_email_is_required'| translate}}
                      </div>
                    </div>

                    <div class="form-group col-md-6" [ngClass]="{'has-danger': birthday.errors && (birthday.dirty || birthday.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.date_of_birth'| translate}}</label>
                      <div class="rmp">
                        <input type="date" name="birthday" value="{{user.birthday}}" [(ngModel)]="user.birthday" #birthday="ngModel" required minDate="1920-01-01"  min="1920-01-01" max="{{birthdayMax}}" class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_age_is_required'| translate}}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (user.gender == 0) && (gender.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.gender'| translate}}</label>
                      <div class="rmp">
                        <select name="gender" [(ngModel)]="user.gender" #gender="ngModel" required class="form-control">
                          <option value="0">{{'front_profil.select'| translate}}</option>
                          <option value="1">{{'front_profil.male'| translate}}</option>
                          <option value="2">{{'front_profil.female'| translate}}</option>
                        </select>
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_gender_is_required'| translate}}
                      </div>
                    </div>
                    <div class="form-group col-md-6" *ngIf="locationCountryCode" >
                      <label class="header-color">{{'front_profil.phone'| translate}}</label>
                      <div class="rmp w-100">
                       <!-- (change)="setPhone()"-->
                        <input class="form-control oinput"  name="phone"
                               type="tel"
                               ng2TelInput
                               (hasError)="hasError($event,error)"
                               (ng2TelOutput)="getNumber($event,number)"
                               (intlTelInputObject)="telInputObject($event,object)"
                               (countryChange)="onCountryChange($event,code)" required />

                        <!-- <input type="text"  name="phone" placeholder="06XXXXXXXXX" value="{{user.phone}}" [(ngModel)]="user.phone" #phone="ngModel" required class="form-control">-->
                      </div>

                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_phone_number_is_required'| translate}}
                      </div>
                    </div>
                  </div>

<!--
                  <div class="row">
                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (user.gender == 0) && (gender.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.gender'| translate}}</label>
                      <div class="rmp">
                        <select name="gender" [(ngModel)]="user.gender" #gender="ngModel" required class="form-control">
                          <option value="0">{{'front_profil.select'| translate}}</option>
                          <option value="1">{{'front_profil.male'| translate}}</option>
                          <option value="2">{{'front_profil.female'| translate}}</option>
                        </select>
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_gender_is_required'| translate}}
                      </div>
                    </div>

                    <div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': (email.errors && (email.dirty || email.touched || errorMsg))}">
                      <label class="header-color">{{'front_profil.email'| translate}}</label>
                      <div class="rmp">
                        <input disabled type="email" name="email" placeholder="Adresse email" #email="ngModel" value="{{user.email}}" [(ngModel)]="user.email" class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_email_is_required'| translate}}
                      </div>
                    </div>
                  </div>

                  <div class="row">

                    <div class="form-group col-md-6"
                         [ngClass]="{'has-danger': birthday.errors && (birthday.dirty || birthday.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.date_of_birth'| translate}}</label>
                      <div class="rmp">
                        <input type="date" name="birthday" value="{{user.birthday}}" [(ngModel)]="user.birthday" #birthday="ngModel" required minDate="1920-01-01"  min="1920-01-01" max="{{birthdayMax}}" class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_age_is_required'| translate}}
                      </div>
                    </div>

                    <div class="form-group col-md-6" *ngIf="locationCountryCode" >
                      <label class="header-color">{{'front_profil.phone'| translate}}</label>
                      <div class="rmp w-100">
                        <input class="form-control oinput" (change)="setPhone()"  name="phone"
                               type="tel"
                               ng2TelInput
                               (hasError)="hasError($event,error)"
                               (ng2TelOutput)="getNumber($event,number)"
                               (intlTelInputObject)="telInputObject($event,objec)"
                               (countryChange)="onCountryChange($event,code)" required />

                        &lt;!&ndash; <input type="text"  name="phone" placeholder="06XXXXXXXXX" value="{{user.phone}}" [(ngModel)]="user.phone" #phone="ngModel" required class="form-control">&ndash;&gt;
                      </div>

                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_phone_number_is_required'| translate}}
                      </div>
                    </div>
                  </div>-->

                  <div class="row">

                    <!--<div class="form-group col-md-6 form-group-required"
                         [ngClass]="{'has-danger': lang.errors && (lang.dirty || lang.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.lang'| translate}}</label>
                      <div class="rmp">
                        <select name="lang" [(ngModel)]="user.lang" #lang="ngModel" required class="form-control">
                          <option value="0">{{'front_profil.select'| translate}}</option>
                          <option value="fr">{{'front_profil.french'| translate}}</option>
                          <option value="en">{{'front_profil.english'| translate}}</option>
                        </select>
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.your_phone_number_is_required'| translate}}
                      </div>
                    </div>-->

                    <div class="form-group col-md-6" *ngIf="!changPassword" [ngClass]="{'has-danger': (password.errors &&  hasPwd && !hasValidPwd()) && (password.dirty || password.touched || errorMsg)}">
                      <label class="header-color">{{'front_profil.password'| translate}}</label>
                      <div class="rmp">
                        <input type="password" [disabled]="changPassword" name="password" value="{{user.password}}" placeholder=" {{'front_profil.change_my_password'| translate}}" [(ngModel)]="user.password" #password="ngModel" [attr.required]="hasPwd ? true : null"  class="form-control">
                      </div>
                      <div class="form-control-feedback alert alert-danger custom-alert-danger">
                        {{'front_profil.a_valid_password_is_required'| translate}}
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <div class="rmp ">
                        <button  class="edit_password_btn" (click)="editPassword($event)">Changer votre mot de passe</button>
                      </div>
                    </div>

                  </div>

                 <!-- <div class="row">

                  </div>-->

                  <div class="form-event-footer form-group form-group-wrapper width-100 text-center" style="margin-top: 35px">
                    <button type="submit" class="edit-btn">Modifier</button>
                  </div>

                </div>
              </form>
            </div>
            <div *ngIf="blocIsVisible('profilDocumentIsActive')">
              <div class="container">
                <h4 class="document-title">Documents</h4>
                <div *ngIf="documentsBlocIsVisible('pieceIdentityTypeList')">
                  <div class="profil-document-header">
                    <h4 class="cl-white text-transform-uppercase fs-18p">pourquoi devez-vous nous envoyer vos justicatifs? </h4>
                    <div>
                      Dans le cadre de la lutte contre le blanchiment d'argent, le financement du terrorisme et de la fraude fiscale ,
                      nous sommes dans l'obligation légale de vérifier votre identité.
                    </div>
                  </div>
                  <div class="mt-45">
                    <div class="choose-justicatif-to-use_title">Sélectionnez un justificatif en cour de validité.</div>
                    <div class="choose-justicatif-to-use_info">
                      Le justificatif que vous devez nous transmettre doit être en cours de validiité. Dans le cas contraire,
                      notre partenaire bancaire ne pourra pas valider votre compte akces.
                    </div>
                  </div>
                  <div class="mt-30">
                    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                      <div class="panel panel-default mb-10" (click)="goToDocumentBlocItem('uploadIdentityFile','identityCard')">
                        <div class="panel-heading active" role="tab" id="headingOne">
                          <h4 class="panel-title">
                            <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              <span class="bloc document-type_label">Carte d'identité</span>
                              <span class="bloc recto-verso">(Recto/verso)</span>
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div class="panel panel-default mb-10"  (click)="goToDocumentBlocItem('uploadIdentityFile','passePort')">
                        <div class="panel-heading" role="tab" id="headingTwo">
                          <h4 class="panel-title">
                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              <span class="bloc document-type_label">Passeport</span>
                              <span class="bloc recto-verso">(Recto/verso)</span>
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div class="panel panel-default mb-10"  (click)="goToDocumentBlocItem('uploadIdentityFile','driverLicence')">
                        <div class="panel-heading" role="tab" id="headingThree">
                          <h4 class="panel-title">
                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              <span class="bloc document-type_label">Permis de conduire</span>
                              <span class="bloc recto-verso">(Recto/verso)</span>
                            </a>
                          </h4>
                        </div>
                      </div>
                      <div class="panel panel-default mb-10"  (click)="goToDocumentBlocItem('uploadIdentityFile','residencePermit')">
                        <div class="panel-heading" role="tab" id="headingFour">
                          <h4 class="panel-title">
                            <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              <span class="bloc document-type_label">Titre de séjour</span>
                              <span class="bloc recto-verso">(Recto/verso)</span>
                            </a>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="documentsBlocIsVisible('uploadIdentityFile')">
                  <div class="upload-document_page_title_one mt-32p">Envoyer une copie de votre {{documentType(userDocument.type)}}</div>
                  <div class="upload-document_page_title_two">Votre document doit avoir les 4 coins lisibles !</div>
                  <div class="center mt-25p"><img src="../../../../assets/imgs/fileupload-icon.png" class="file-upload-icon" /></div>
                  <div class="form-check mt-10p">
                    <input class="form-check-input boder-radius-unset" type="checkbox" [checked]="userDocument.isRectoVerso" (change)="sameDocumentRectoVersoChange($event)" id="sameDocumentRectoVerso">
                    <label class="form-check-label fs-13p" for="sameDocumentRectoVerso">
                      Recto/verso sur le même document
                    </label>
                  </div>
                  <input style="display: none" (change)="rectoVersoFileListenner($event)" id="recotVerso" type="file" class="form-control">
                  <div *ngIf="userDocument.isRectoVerso" class="mt-20p">
                    <div class="col-md-3 m-auto center add-pic-btn" (click)="openRectoVersoFile($event)">
                      <div>
                        <i class="fa fa-plus-circle fs-large" aria-hidden="true"></i>
                      </div>
                      <span class="bloc">Recto/Verso</span>
                      <span class="bloc">Photo/scan</span>
                      <span class="bloc">JPEG ou PDF</span>
                    </div>
                  </div>
                  <div class="row mt-20p" *ngIf="!userDocument.isRectoVerso">
                    <div class="col-md-3 m-auto center add-pic-btn" (click)="openRectoFile($event)">
                      <div>
                        <i class="fa fa-plus-circle fs-large" aria-hidden="true"></i>
                      </div>
                      <span class="bloc">Recto</span>
                      <span class="bloc">Photo/scan</span>
                      <span class="bloc">JPEG ou PDF</span>
                    </div>
                    <div class="col-md-3 m-auto center add-pic-btn" (click)="openVersoFile($event)">
                      <div>
                        <i class="fa fa-plus-circle fs-large" aria-hidden="true"></i>
                      </div>
                      <span class="bloc">Verso</span>
                      <span class="bloc">Photo/scan</span>
                      <span class="bloc">JPEG ou PDF</span>
                    </div>
                  </div>
                  <div class="form-check mt-25p">
                    <input class="form-check-input boder-radius-unset" type="checkbox" [checked]="confirmDocumentNotExpired" (change)="confirmDocumentNotExpiredChange($event)" value="" id="identityConfirm">
                    <label class="form-check-label fs-13p" for="identityConfirm">
                      Je confirme que mon document d'identité n'est pas expiré et est mis en couleurs.
                    </label>
                  </div>

                  <div class="center mt-15p">
                    <div class="row col-md-12 margin-auto">
                      <button class="upload-step-btn" (click)="goToDocumentBlocItem('pieceIdentityTypeList')">Retour</button>
                      <button class="upload-step-btn next-color ml-10p" (click)="continueToConfirmDocumentForm()">Continuer</button>
                    </div>
                  </div>
                </div>
                <div *ngIf="documentsBlocIsVisible('identityConfirmForm')">
                  <div class="document-subtitle mt-10p">Est-ce bien l'idendité qui figure sur le permis de le condiure que vous nous avez transmis?</div>
                  <div class="mt-15p">
                    <div class="center">
                      Dans le cadre de la validation de votre compte, vous devez renseigner les mêmes nom et prénom que
                      ceux inscrits sur le justificatif d'idendité que vous venez de télécharger.
                    </div>
                    <div class="center">Nous vous demandons également de bien vouloir nous indiquer votre date de naissance.</div>
                    <div class="center"> Si les informations saisies ne sont pas correctes,nous ne pourrons pas valider votre compte Akces.</div>
                  </div>
                  <div class="container mt-30p">
                    <form (ngSubmit)="onSubmitUploadConfirm(uploadConfirm.valid)" #uploadConfirm="ngForm">
                      <div class="row col-md-12">
                        <div class="form-group col-md-6 form-group-required" [ngClass]="{'has-danger': uploadConfirmName.errors && (uploadConfirmName.dirty || uploadConfirmName.touched || errors.length)}">
                          <label for="firstName">Nom</label>
                          <input id="firstName" type="text" required name="uploadConfirmName" [(ngModel)]="userDocument.lastName" class="form-control" #uploadConfirmName="ngModel">
                          <div class="form-control-feedback alert alert-danger custom-alert-danger">
                            Le nom est requis
                          </div>
                        </div>
                        <div class="form-group col-md-6 form-group-required" [ngClass]="{'has-danger': uploadConfirmLastName.errors && (uploadConfirmLastName.dirty || uploadConfirmLastName.touched || errors.length)}">
                          <label for="lastName">Prénom</label>
                          <input id="lastName" type="text" required name="uploadConfirmLastName"  [(ngModel)]="userDocument.firstName" class="form-control" #uploadConfirmLastName="ngModel">
                          <div class="form-control-feedback alert alert-danger custom-alert-danger">
                            Le prénom est requis
                          </div>
                        </div>
                        <div class="form-group col-md-12 form-group-required" [ngClass]="{'has-danger': uploadConfirmBirthDate.errors && (uploadConfirmBirthDate.dirty || uploadConfirmBirthDate.touched || errors.length)}">
                          <label for="birthDate">Date de naissance</label>
                          <input id="birthDate" type="date" required name="uploadConfirmBirthDate" [(ngModel)]="userDocument.birthDate" class="form-control" #uploadConfirmBirthDate="ngModel">
                          <div class="form-control-feedback alert alert-danger custom-alert-danger">
                            La date de naissance requise
                          </div>
                        </div>
                      </div>
                    </form>

                    <div class="mt-30p">
                      <div>Etes vous bien certains de ces informations ?</div>
                      <div>Elles sont essentielles pour la vérification par notre équipe conformité.</div>
                    </div>

                    <!--<div class="center mt-30p">
                      <button class="save-document-btn">enrégistrer</button>
                    </div>-->
                    <div class="center mt-15p">
                      <div class="row col-md-9 margin-auto">
                        <button class="upload-step-btn" (click)="goToDocumentBlocItem('uploadIdentityFile')">Retour</button>
                        <button class="upload-step-btn ml-10p" (click)="saveDocumentData($event)">Enrégistrer</button>
                      </div>
                    </div>
                  </div>

                </div>
                <div *ngIf="documentsBlocIsVisible('confirm')">
                  <div class="mt-25p" *ngIf="!userDocument.isValidated">
                    <div class="center upload-confirm_title_one">Merci pour votre confiance ! Votre document d'identité a bien été envoyé.</div>
                    <div class="center upload-confirm_title_two">Dès que votre document sera validé, nous vous informerons par mail.</div>
                    <div class="document-upload_box mt-20">
                      <span class="block">{{documentType(userDocument.type)}}</span>
                      <span class="block">Ajouté le: {{userDocument.created_at|date:'d/MM/yyyy'}}</span>
                      <span class="block document-uploaded_notvalidated">En attente de validation</span>
                    </div>
                  </div>
                  <div class="mt-25p" *ngIf="userDocument.isValidated">
                    <div class="center upload-confirm_title_one">Votre document d'identité a bien été validé!</div>
                    <div class="center upload-confirm_title_two">Vous pouvez désormais effectuer des virements vers "Votre compte"</div>
                    <div class="document-upload_box mt-20">
                      <span class="block">Document d'identité</span>
                      <span class="block">Ajouté le: {{userDocument.created_at|date:'d/MM/yyyy'}}</span>
                      <span class="block document-uploaded_validated">Accepté</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="blocIsVisible('profilRibIsActive')"  style="margin-bottom: 150px">
              <app-payment-data-form [user]="user"></app-payment-data-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
